export default {
  ADD_CLUSTERLET: 'ADD_CLUSTERLET',
  SET_REACT_FLOW_INSTANCE: 'SET_REACT_FLOW_INSTANCE',
  EDIT_CLUSTERLET: 'EDIT_CLUSTERLET',
  DELETE_CLUSTERLET: 'DELETE_CLUSTERLET',
  UPDATE_FULL_CLUSTERLETS: 'UPDATE_FULL_CLUSTERLETS',
  RESET_CLUSTERLETS: 'RESET_CLUSTERLETS'
};
